export default function Footer() {
  return (
    <div className="w-full h-[50px] flex justify-center items-center border-t border-mono-75">
      <div className="w-[320px] h-full px-4 flex justify-between items-center">
        <a
          className="text-[12px] font-normal font-['Inter']"
          href="mailto:info@pointmentapp.com"
        >
          info@pointmentapp.com
        </a>
        <div className="w-0.5 h-0.5 bg-mono-black rounded-sm" />
        <p className="text-[12px] font-normal font-['Inter']">
          © Pointment {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
